export interface InitialState {
  filters: string
}

export const initialState: InitialState = {
  filters: `?limit=500`
}
